module.exports = __webpack_public_path__ + "img/SKMJ_evaluationProcess.3fc2f3f0.png";